export default __webpack_public_path__ + "static/FirstsafetyFeatureTwo-134ebb1bc534a4b573abc2ddff36116d.webp";